// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  if(evt.detail.variant){
    window.selectedVariant = evt.detail.variant;
    window.selectedVariantTitle = evt.detail.variant.title;
    if(evt.detail.variant.available){
      document.querySelector('#klavio-oos').style.display = 'none';
    }else{
      document.querySelector('#klavio-oos').style.display = 'block';
      document.querySelector('.klaviyo-bis-trigger').style.display = 'flex';
    }
  }
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});




gsap.registerPlugin(ScrollTrigger);
//responsive
let gsap_mm = gsap.matchMedia();
gsap_mm.add("(min-width: 720px)", () => {
    ourFashionOut_section();
    aboutHorizontal_section();
});

function ourFashionOut_section(){
  let ourFashionOut = '.our-fashion';

  gsap.from(ourFashionOut, {
    scrollTrigger: {
      trigger:ourFashionOut,
      start:'-300px center',
      end : '200px center',
      //markers: true,
      scrub:true
    },
    scale:'.85',
    borderRadius:'30px',
    duration:2
  })
}

function aboutHorizontal_section(){
 
  const sections = gsap.utils.toArray(".about-horizontal-block");

  if(!sections.length) return;

  let xPercent = -100 * (sections.length - 1);
  let scrollTween = gsap.to(sections, {
    xPercent: xPercent,
    ease: "none",
    scrollTrigger: {
      trigger: ".about-horizontal-blocks",
      pin: true,
      scrub: 1,
      end: `+=${document.querySelector(".about-horizontal-blocks").offsetWidth}`,
      snap: {
        snapTo: 1 / (sections.length - 1), // snap to the closest label in the timeline
        duration: 0.5,
        delay: 0,
        //ease: "power1.inOut"
      },
      
      onEnter: function(){
        document.querySelector('header').classList.add('white')
      },
      onEnterBack : function(){
        document.querySelector('header').classList.add('white')
      },
      onLeave: function(){
        document.querySelector('header').classList.remove('white')
      }
    }
  });
  
  
  // whizz around the sections
  // sections.forEach((section) => {
  //   // grab the scoped text
  //   let text = section.querySelectorAll("h2");
    
  //   // bump out if there's no items to animate
  //   if(text.length === 0)  return 
    
  //   // do a little stagger
  //   gsap.from(text, {
  //     y: -130,
  //     opacity: 0,
  //     duration: 2,
  //     ease: "elastic",
  //     stagger: 0.1,
  //     scrollTrigger: {
  //       trigger: section,
  //       containerAnimation: scrollTween,
  //       start: "left center",
  //       markers: true
  //     }
  //   });
  // });
}

function openCalandly(){
  var link = window.calendly_links.find(link => {
    return link.id == selectedVariant.id;
  })
  console.log(link)
  if(link){
    Calendly.showPopupWidget(link.link + '?a2=' + window.selectedVariantTitle);   
  }
  
}


function playReel(elm, id) {
  var video = document.querySelector('#reel-' + id);
  if(video){
    playReelVideo(video) 
  }
  
}

function playReelVideo(video) {
  if(video){
    
    
    const promise = video.play();
    if(promise !== undefined){
        promise.then(() => {
            // Autoplay started
            video.nextElementSibling.classList.add('playing');
        }).catch(error => {
            // Autoplay was prevented.
            video.nextElementSibling.classList.remove('playing');
        });
    }
  }
  
}

function pauseReel(elm) {
  if(elm){
    elm.pause();
    elm.nextElementSibling.classList.remove('playing');
    
  }
  
}

function loadPreviuosReel(url) {
  
  var container = document.querySelector(".article__inner-left-inner"),
      containerHeight = container.offsetHeight + 30;
  container.classList.add('scrolling');
  container.style.transform = 'translateY(-'+containerHeight+'px)';
  reloadReel(url)
}

function loadNextReel(url) {
  var container = document.querySelector(".article__inner-left-inner"),
      containerHeight = container.offsetHeight + 30;
  container.classList.add('scrolling');
  container.style.transform = 'translateY('+containerHeight+'px)';
  reloadReel(url)
}

function reloadReel(url) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState != 4 || xhr.status != 200) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(xhr.responseText, "text/html");
    var element = doc.querySelector(".article__inner-left");
    
    if (element) {
        setTimeout(function(){
          document.querySelector(".article__inner-left").innerHTML = element.innerHTML;

          swipeReels()
        }, 300)
    } else {
      console.error("Element with ID 'myElement' not found in the response.");
    }
  };
  xhr.send();
  //history.pushState(url, '', url);
}

function swipeReels() {
    var container = document.querySelector(".article__inner-left");

  container.addEventListener("touchstart", startTouch, false);
  container.addEventListener("touchmove", moveTouch, false);
  
 
  // Swipe Up / Down / Left / Right
  var initialX = null;
  var initialY = null;

  function startTouch(e) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  function moveTouch(e) {
    if (initialX === null) {
      return;
    }

    if (initialY === null) {
      return;
    }

    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;

    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    if (Math.abs(diffX) > Math.abs(diffY)) {
      // sliding horizontally
      if (diffX > 0) {
        // swiped left
        console.log("swiped left");
      } else {
        // swiped right
        console.log("swiped right");
      }  
    } else {
      // sliding vertically
      if (diffY > 0) {
        // swiped up
        if(container.querySelectorAll('.reels-video-links a')[1]){
          //window.location.href = container.querySelectorAll('.reels-video-links a')[1].getAttribute('href');
          loadPreviuosReel(container.querySelectorAll('.reels-video-links a')[1].getAttribute('href'))
        }
      } else {
        // swiped down
        if(container.querySelectorAll('.reels-video-links a')[0]){
          //window.location.href = container.querySelectorAll('.reels-video-links a')[0].getAttribute('href');
          loadNextReel(container.querySelectorAll('.reels-video-links a')[0].getAttribute('href'))
        }
      }  
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
  };
  
}

function updateBar(video){
    
    var currentPos = video.currentTime; //get currentime
    var maxduration = video.duration; //get video duration
    var percentage = (100 * currentPos / maxduration);
    video.closest('.reels-video').querySelector(".reels-video-proggress").style.width = (percentage + '%');
}